import { render } from "./WheelOfNamesDialog.vue?vue&type=template&id=52a7093a"
import script from "./WheelOfNamesDialog.vue?vue&type=script&lang=js"
export * from "./WheelOfNamesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__